import { SyncOutlined, WarningFilled } from '@ant-design/icons';
import { ISODate } from '@framework/ui/components/date/ISODate.tsx';
import { Space } from 'antd';
import { type useLastLoginHistory } from './useLastLoginHistory.ts';

export interface ILastLoginTextProps {
  isLink?: boolean;
  historyData: ReturnType<typeof useLastLoginHistory>;
}

/**
 * Testo del pulsante che mostra l'ultimo accesso dell'utente e se cliccato mostra un Drawer con gli ultimi 10 accessi
 */
export function LastLoginText(props: ILastLoginTextProps) {
  const { isLink, historyData } = props;
  const { history, isLoading, error } = historyData;

  if (isLoading) {
    return (
      <Space>
        <SyncOutlined spin />
        Caricamento dati...
      </Space>
    );
  }

  if (error) {
    return (
      <Space style={{ color: 'red' }}>
        Errore di caricamento dati storia login
        <WarningFilled />
      </Space>
    );
  }

  return (
    <Space
      size={isLink ? 'small' : 0}
      direction={isLink ? 'horizontal' : 'vertical'}
      style={{ lineHeight: 1.2 }}
    >
      <span>Ultimo accesso:</span>
      {history.length > 0 ? (
        <b>
          <ISODate
            date={history[0]?.dataAccesso}
            format="DD/MM/YYYY HH:mm:ss"
          />
        </b>
      ) : (
        <span>Nessun accesso registrato</span>
      )}
    </Space>
  );
}
